import React, { Component } from 'react';
import { connect } from 'react-redux';
import { login, logout, keepLogin } from '../redux/Action';
import { Button, Input } from 'reactstrap';
// import Axios from 'axios';
import { Redirect } from 'react-router-dom';
// import { API_URL } from '../API_url/API_URL';

class Login extends Component{

    loginUser = () => {
        let username = this.text.value;
        let password = this.pass.value;
        if(username === '' || password === ''){
            alert('Fill in all the forms')
        }else if(username){
            localStorage.setItem('username', username)
            this.props.login(username, password)
            this.props.keepLogin()
        }
    }

    render(){
        if(this.props.username !== ''){
            return(
                <Redirect to='/'>

                </Redirect>
            )
        }

        console.log(this.props.count)
        console.log(this.props.username)
        console.log(this.props.role)
        return(
            <div className='d-flex justify-content-center row'>
                <div>
                    <center>
                    Username
                    <br/>
                    <Input type='text' placeholder="username or Email" innerRef={(text) => this.text = text}/>
                    Password
                    <br/>
                    <Input type='password' placeholder="password" innerRef={(pass) => this.pass = pass}/>
                    <br/>
                    <Button  onClick={this.loginUser}>
                        Sign-In
                    </Button>
                    </center>
                </div>
            </div>
        )
    }
}

const mapStatetoProps = ({auth}) => {
    return {
        username: auth.username,
        password: auth.password,
        email: auth.email,
        role: auth.role
    }
}

export default connect(mapStatetoProps, { login, logout, keepLogin })(Login)